import moment from "moment";

export const EX_DATE = "01/01/1900";

export const LOCALSTORAGE = {
    translations: "translations",
    lang: "lang"
}
export const FALLBACK_LANG = "en";

export const LANG = window.localStorage.getItem("lang") || FALLBACK_LANG;

export const toLocalTZ = (date, format) => {
    return date;
    const dateFormat = (format) ? format : 'MM/DD/YYYY hh:mm:ss A';
    const testDateUtc = moment.utc(date);
    const localDate = testDateUtc.local();
    return localDate.format(dateFormat);
}

export const INVOICE_TYPE = {
    // Service:"Service",
    Logistics: "Logistics",
    NOPO: "NOPO"
};

export const FIXED_UPTO_3 = 3;

export const FIXED_UPTO_4 = 4;

export const UOM = ['AU', 'LB', 'EA', 'RL', 'CAR', 'FT', 'BOX', 'PAA', 'TON', 'KG', 'QT', 'D', 'GM3', 'BA', 'BAG', 'BD', 'BO', 'BT', 'BR', 'CA', 'CT', 'CL', 'DR', 'DZ', 'FT2', 'FT3', 'GAL', 'H', 'YR', 'CAN', 'KE', 'KIT', 'KT', 'L', 'LF', 'LFC', 'PAC', 'PAL', 'PH', 'PT', 'RM', 'SH', 'SP', 'PC', 'ST', 'HR', 'TB', 'TS', 'UN', 'WB', 'YD'];

export const UOM_MAPPING = [{ "commercial_uom": "AU", "technical_uom": "LE" }, { "commercial_uom": "BA", "technical_uom": "BA" }, { "commercial_uom": "BAG", "technical_uom": "BAG" }, { "commercial_uom": "BD", "technical_uom": "BD" }, { "commercial_uom": "BO", "technical_uom": "BO" }, { "commercial_uom": "BOX", "technical_uom": "BX" }, { "commercial_uom": "BR", "technical_uom": "BR" }, { "commercial_uom": "BT", "technical_uom": "BOT" }, { "commercial_uom": "CA", "technical_uom": "CA" }, { "commercial_uom": "CAN", "technical_uom": "KAN" }, { "commercial_uom": "CAR", "technical_uom": "KAR" }, { "commercial_uom": "CL", "technical_uom": "CTL" }, { "commercial_uom": "CT", "technical_uom": "CT" }, { "commercial_uom": "D", "technical_uom": 10 }, { "commercial_uom": "DR", "technical_uom": "DR" }, { "commercial_uom": "DZ", "technical_uom": "DZ" }, { "commercial_uom": "EA", "technical_uom": "EA" }, { "commercial_uom": "FT", "technical_uom": "FT" }, { "commercial_uom": "FT2", "technical_uom": "FT2" }, { "commercial_uom": "FT3", "technical_uom": "FT3" }, { "commercial_uom": "GAL", "technical_uom": "GLL" }, { "commercial_uom": "GM3", "technical_uom": "A93" }, { "commercial_uom": "H", "technical_uom": "H" }, { "commercial_uom": "HR", "technical_uom": "STD" }, { "commercial_uom": "KE", "technical_uom": "KE" }, { "commercial_uom": "KG", "technical_uom": "KG" }, { "commercial_uom": "KIT", "technical_uom": "KIT" }, { "commercial_uom": "KT", "technical_uom": "KT" }, { "commercial_uom": "L", "technical_uom": "L" }, { "commercial_uom": "LB", "technical_uom": "LB" }, { "commercial_uom": "LF", "technical_uom": "LF" }, { "commercial_uom": "LFC", "technical_uom": "LFC" }, { "commercial_uom": "PAA", "technical_uom": "PAA" }, { "commercial_uom": "PAC", "technical_uom": "PAK" }, { "commercial_uom": "PAL", "technical_uom": "PAL" }, { "commercial_uom": "PC", "technical_uom": "ST" }, { "commercial_uom": "PH", "technical_uom": "PH" }, { "commercial_uom": "PT", "technical_uom": "PT" }, { "commercial_uom": "QT", "technical_uom": "QT" }, { "commercial_uom": "RL", "technical_uom": "RL" }, { "commercial_uom": "RM", "technical_uom": "RM" }, { "commercial_uom": "SH", "technical_uom": "SH" }, { "commercial_uom": "SP", "technical_uom": "SP" }, { "commercial_uom": "ST", "technical_uom": "ST1" }, { "commercial_uom": "TB", "technical_uom": "TB" }, { "commercial_uom": "TON", "technical_uom": "TON" }, { "commercial_uom": "TS", "technical_uom": "TH" }, { "commercial_uom": "UN", "technical_uom": "UN" }, { "commercial_uom": "WB", "technical_uom": "WB" }, { "commercial_uom": "YD", "technical_uom": "YD" }, { "commercial_uom": "YR", "technical_uom": "JHR" }];

export const POSTING_KEYS = [
    { value: "40", label: "Dr" },
    { value: "50", label: "Cr" }
]

export const GL_AC_NO_DEFAULT = ["8900000000", "6403090000"];
export const GL_AC_DEC_DEFAULT = ["MISC EXP/OS Other", "TAXES - SALES & USE TAX"];

//export const ROLES = ["Super Admin", "Admin", "Team Lead", "Employee", "AP"];

export const DEFAULT_CURR = "USD";

export const DEFAULT_COMP = "1970";

export const SAP_POWER_AUTOMATE_REQ = (requiredFeildName = "", poNum = "", indicator = "") => {
    return {
        "Required Filter Name": requiredFeildName,
        "Company Code": DEFAULT_COMP,
        "Plant Code": DEFAULT_COMP,
        "PO Number": poNum,
        "Indicator": indicator
    };
}

export const INT_APPROVER_VAL = { value: '', label: '', email: "", userId: 0 };

export const TASK_STATUS = [{ value: 'New', label: 'New' },
{ value: 'In Progress', label: 'In Progress' },
{ value: 'Hold', label: 'Hold' },
{ value: 'Approved', label: 'Approved' },
{ value: 'Rejected', label: 'Rejected' },
{ value: 'Deleted', label: 'Deleted' },
    // { value: 'Posted', label: 'Posted' }
];

export const TASK_STATUS_MY = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Hold', label: 'Hold' },
];

export const TASK_SUB_STATUS = [{ value: 'Unassigned', label: 'Unassigned' },
{ value: 'Assigned', label: 'Assigned' },
{ value: 'Email To Vendor', label: 'Email To Vendor' },
{ value: 'Under Approval', label: 'Under Approval' },
// { value: 'Exception', label: 'Exception' },
{ value: 'Posted', label: 'Posted' }]

export const TASK_SUB_STATUS_MY = [
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Email To Vendor', label: 'Email To Vendor' }]

// Request Methods
export const GET = "GET"
export const POST = "POST"
export const PATCH = "PATCH"
export const PUT = "PUT"
export const DELETE = "DELETE"


// Headers
export const HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

export const HEADERS_UPLOAD = {
    'Content-Type': 'multipart/form-data',
};

// API
export const LOGIN = `/v1/login?api-version=1`;
export const VALIDATE_EMAIL = (emailId) => `/v1/validateLogin?emailId=${emailId}&api-version=1`;
export const GET_TASKLISTING = `/v1/tasks/SearchTasks?api-version=1`;
export const GET_TASK = (taskId) => `/v1/tasks/${taskId}?api-version=1`;
export const POST_TASK_SEARCH = `/v1/tasks/search?api-version=1`;
export const GET_TASKLISTING_PROCESSED = `/v1/tasks/getTaskProcessed?api-version=1`;
export const GET_TASKLISTING_UNPROCESSED = `/v1/tasks/getTaskUnProcessed?api-version=1`;
export const GET_TASK_FILTERS = `/v1/tasks/SearchTasksFilters?api-version=1`;
export const DELETE_TASK_FILTERS = (taskId) => `/v1/tasks/deletefilter/${taskId}?api-version=1`;
export const GET_INV_MATCHING = (taskId) => `/v1/invoice/GetInvoiceMatching?taskId=${taskId}&api-version=1`;
export const GET_EMAIL = `/v1/tasks/getEmail?api-version=1`;
export const GET_COMMENTS = (taskId) => `/v1/invoice/getInvoiceComments?taskId=${taskId}&api-version=1`;
export const GET_APPROVAL_LEVEL = (amount, invoiceType, companyCode) => `/v1/configData/getApprovalLevel?amount=${amount}&invoiceType=${invoiceType}&companyCode=1970&api-version=1`;
export const GET_USERS = `/v1/userManagement/getUserRoleList?api-version=1`;
export const POST_INV_MATCHING = `/v1/invoice/AddInvoiceMatching?api-version=1`;
export const POST_INV_UNMATCHING = `/v1/invoice/DeleteInvoiceMatching?api-version=1`;
export const UPLOAD_ATTACH = `/v1/attachment/addAttachments?api-version=1`;
export const GET_ATTACH = (TaskId) => `/v1/attachment/getAttachments?TaskId=${TaskId}&api-version=1`;
export const DELETE_ATTACH = `/v1/attachment/deleteAttachments?api-version=1`;
export const GET_AUTO_ASSIGN = `/v1/configData/getAutoAssigningData?api-version=1`;
export const POST_AUTO_ASSIGN = `/v1/configData/addUpdateAutoAssigning?api-version=1`;
export const POST_CHECK_DUPLICATE_SUBMIT = `/v1/tasks/check-duplicate-submit?api-version=1`;
export const POST_INVOICE_DETAILS_SAVE = `/v1/invoice/AddInvoiceHeaderLineItem?api-version=1`;
export const POST_SAVE_TASK = `/v1/tasks/addTasks?api-version=1`;
export const POST_SAVE_FILTER = `/v1/tasks/AddTasksFilters?api-version=1`;
export const POST_ADD_COMMENT = `/v1/invoice/addInvoiceComment?api-version=1`;
export const POST_SEND_EMAIL = `/v1/tasks/sendEmail?api-version=1`;
export const PUT_UPDATE_TASK = `/v1/tasks/updateTasksStatus?api-version=1`;
export const PUT_UPDATE_INVOICE_ASSIGNEE = (taskId) => `/v1/invoice/updateInvoiceAssignee/${taskId}?api-version=1`;
export const EXCEPTION_COMMENTS = (exceptionQueueId) => `/v1/exception/getExceptionQueueComments?ExceptionQueueId=${exceptionQueueId}&api-version=1`;
export const EXCEPTION_COMMENTS_POST = `/v1/exception/addExceptionQueueComment?api-version=1`;
export const EXCEPTION_COMMENTS_UPDATE = `/v1/exception/addUpdateException?api-version=1`;
export const TASK_COUNT = `/v1/tasks/TaskCount?api-version=1`;
export const POST_COMPANYPLANTVENDOR = process.env.REACT_APP_POST_COMPANYPLANTVENDOR;
export const POST_SUBMIT_WORKFLOW = process.env.REACT_APP_POST_SUBMIT_WORKFLOW;
export const PO_HISTORY = process.env.REACT_APP_POST_PO_HISTORY;
export const POST_DUP_CHECK = process.env.REACT_APP_POST_POST_DUP_CHECK;
export const UPLOAD_FILE_TO_BLOB = process.env.REACT_APP_POST_UPLOAD_FILE_TO_BLOB;
export const CURENCY_LIST = process.env.REACT_APP_POST_CURENCY_LIST;
export const UPLOAD_ATTACH_SAP = process.env.REACT_APP_POST_UPLOAD_ATTACH;


//USER MANAGEMENT API URLS
export const getUsersList = `/v1/userManagement/getUserRoleList?api-version=1`;
export const verifyUserEmail = `/v1/userManagement/verifyEmail?api-version=1`;
export const addUser = `/v1/userManagement/addUserRole?api-version=1`;
export const updateUserStatus = (roleAssignedId) => `/v1/userManagement/updateUserStatus/${roleAssignedId}?api-version=1`;
export const addRole = `/v1/userManagement/addRole?api-version=1`;
export const updatedRoleStatus = (roleId) => `/v1/userManagement/updateRoleStatus/${roleId}?api-version=1`;
export const getRoles = `/v1/userManagement/getUserRoleList?api-version=1`;
export const getRolesMenuList = `/v1/userManagement/getRoleMenuList?api-version=1`;
export const getMenuList = `/v1/userManagement/getMenuList?api-version=1`;
export const addUpdateMenu = `/v1/userManagement/addUpdateMenu?api-version=1`;
export const deleteMenu = (id) => `/v1/userManagement/menu/${id}?api-version=1`;
export const addRoleMenuMapping = `/v1/userManagement/addRoleMenuMapping?api-version=1`;
export const getRoleAssignedMenu = `/v1/userManagement/getUserRolesAssignedWithMenus?api-version=1`;
export const updateAssignRole = (roleAssignedId) => `/v1/userManagement/updateAssignRole/${roleAssignedId}?api-version=1`;
export const EXCEPTION_LIST = `/v1/exception/getExceptionList?api-version=1`;
export const DUP_CHECK = `/v1/invoice/duplicateInvoiceCheck?api-version=1`;
// Aduit Trails
export const GET_AUDIT_TRAIL_BY_TASK_ID = `/v1/configData/getAuditTrailByTaskId`
export const GET_STATIC_REPORT = `/v1/report/getStaticReport?userId=1&api-version=1`
export const GET_REPORT_COLUMNS = `/v1/report/getColumnList?userId=1&api-version=1`
export const GET_REPORT_FILTER = `/v1/report/getFilterList?userId=1&api-version=1`
export const POST_REPORT_ADHOC = `/v1/report/getAdHocReport?userId=1&api-version=1`

//ERROR Reports
export const POST_SAPERROR_REPORT = `/v1/report/getSAPErrorLogReport?api-version=1`
